export default __webpack_public_path__ + "static/media/Organizacion.6eccbd0b.jpg";